import { render, staticRenderFns } from "./fire-underwirting-refer.vue?vue&type=template&id=fb16cf3e&"
import script from "./fire-underwirting-refer.vue?vue&type=script&lang=js&"
export * from "./fire-underwirting-refer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports